(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_955ba45"] && !Shopify.designMode) return;
  try {
    class VariantMetafieldDisplay extends HTMLElement {
    constructor() {
      super();
      this.emptyText = this.dataset.empty || '';
      this.sectionId = this.dataset.mainSection || '';
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      document.addEventListener('variant:change', this.handleVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.handleVariantChange);
    }

    handleVariantChange({ detail }) {
      const { id, trigger } = detail;

      // Ensure event belongs to this section
      if (!trigger || trigger.id !== this.sectionId) return;

      const container = this.querySelector('.variant-container');
      if (!container) return;

      const templateVariant = this.querySelector(`template#variant-${id}`);
      container.innerHTML = '';

      container.appendChild(
        templateVariant ? templateVariant.content.cloneNode(true) : document.createTextNode(this.emptyText)
      );
    }
  }

  customElements.define('variant-metafield-display', VariantMetafieldDisplay);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_d99434b"] && !Shopify.designMode) return;
  try {
    class MetafieldMedia extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.mainSection ?? null;
      this.imageKey = this.dataset.imageKey ?? null;
      this.videoKey = this.dataset.videoKey ?? null;
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.currentMedia = null;
    }

    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.templateContent = this.querySelector('template')?.content;
      this.currentMedia = this.querySelector('img, video');
      this.checkMediaPresence();
      document.addEventListener('variant:change', this.handleVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.handleVariantChange);
    }

    handleVariantChange({ detail }) {
      const { id, trigger } = detail ?? {};
      if (trigger?.id !== this.sectionId) return;

      const newMedia = this.getMediaByVariantId(id);

      if (newMedia) {
        this.replaceMedia(newMedia);
      } else {
        this.hideCurrentMedia();
      }

      this.toggleSection();
    }

    replaceMedia(newMedia) {
      if (!this.currentMedia) {
        this.appendChild(newMedia);
      } else {
        this.currentMedia.replaceWith(newMedia);
      }

      newMedia.classList.remove('is-hidden');
      this.currentMedia = newMedia;

      if (newMedia.tagName === 'VIDEO') {
        newMedia.play();
      }

      this.checkMediaPresence();
    }

    hideCurrentMedia() {
      if (this.currentMedia) {
        this.currentMedia.classList.add('is-hidden');
      }
    }

    checkMediaPresence() {
      const hasMedia = this.querySelector('img, video') !== null;
      this.classList.toggle('no-media', !hasMedia);
    }

    getMediaByVariantId(id) {
      let mediaElement = this.templateContent?.querySelector(`img[data-id="${id}"][data-image-key="${this.imageKey}"]`);

      if (!mediaElement) {
        mediaElement = this.templateContent?.querySelector(`video[data-id="${id}"][data-video-key="${this.videoKey}"]`);
      }

      if (!mediaElement) {
        mediaElement = this.templateContent?.querySelector(`img[data-id="${id}"], video[data-id="${id}"]`);
      }

      return mediaElement ? mediaElement.cloneNode(true) : null;
    }

    toggleSection() {
      if (!this.section) return;

      const allMedia = this.section.querySelectorAll('metafield-media img, metafield-media video');
      const isAllHidden = [...allMedia].every((media) => media.classList.contains('is-hidden'));

      this.section.classList.toggle('images-hidden', isAllHidden);
    }
  }

  if (!customElements.get('metafield-media')) {
    customElements.define('metafield-media', MetafieldMedia);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["klarna-placement"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('klarna-placement').then(function () {
    document.querySelectorAll('style[data-klarna-placement]').forEach(function (styleTag) {
      const klarnaElement = styleTag.closest('.klarna-placement-inner').querySelector('klarna-placement');
      if (!klarnaElement?.shadowRoot) return;
      klarnaElement.shadowRoot.appendChild(styleTag);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pre-order"] && !Shopify.designMode) return;
  try {
    class PreOrder extends HTMLElement {
    constructor() {
      super();
      this.handleVariantChange = this.variantChange.bind(this);
      this.isAdded = false;
    }

    get inputs() {
      return Array.from(this.querySelectorAll("input[type='hidden']"));
    }

    get inputsNeedForm() {
      return this.inputs.every((input) => !input.hasAttribute('form'));
    }

    connectedCallback() {
      if (!this.isAdded) this.handleVariantChange();
      document.addEventListener('variant:theme:updated', this.handleVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:theme:updated', this.handleVariantChange);
    }

    variantChange(event) {
      if (!this.inputsNeedForm) return;
      setTimeout(() => {
        const section = this.closest('.shopify-section');
        const productForm = section?.querySelector('product-form-component form.shopify-product-form');
        const productFormId = productForm.getAttribute('id');
        if (!productFormId) return;
        this.inputs.forEach((input) => input.setAttribute('form', productFormId));
        this.isAdded = true;
      }, 0);
    }
  }

  if (!customElements.get('pre-order')) {
    customElements.define('pre-order', PreOrder);
  }
  } catch(e) { console.error(e); }
})();

})();
